import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { APP_PATHS, PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/')({
  validateSearch: zodValidator(withDefaults(schema.RULES, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!(
      (context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RULES, app: APP_PATHS.DETECTIONS }) ||
        context.userPermissions.hasAllowedPermission({
          path: PAGE_PATHS.RULES,
          app: APP_PATHS.DETECTIONS,
          permission: Permission.UPDATE,
        })) &&
      context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      })
    );
    context.validatePermissions({ isAllowed, preload });
  },
});
